import { Button } from '@grupoboticario/flora-react';
import styled, { css } from 'styled-components';
import { CgArrowLeft } from 'react-icons/cg';
import { BreadcrumbProps } from './index';

export const Wrapper = styled.div<BreadcrumbProps>`
  display: flex;
  align-items: center;
  padding: 24px 10px 24px;
  background-color: ${({ theme, color }) =>
    color === 'standard' ? theme.colors.background : theme.colors.shape};
`;

export const HomeIcon = styled(CgArrowLeft)`
  width: 27px;
  height: 27px;
  margin: 4px 18px 0 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.main};
`;

export const ArrowIcon = styled.div`
  width: 8px;
  height: 12px;
  margin: 0 12px;
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-6.16331e-08 10.59L4.58 6L-4.62904e-07 1.41L1.41 -6.16331e-08L7.41 6L1.41 12L-6.16331e-08 10.59Z' fill='%23878787'/%3E%3C/svg%3E ");
`;

export const ButtonStep = styled(Button).attrs({
  hierarchy: 'tertiary',
})<{ islast: string }>`
  font-size: 18px;
  font-style: normal;
  line-height: 32px;
  letter-spacing: 0em;
  height: auto;
  color: #222222;
  :hover {
    background-color: transparent;
  }
  ${({ islast }) =>
    islast === 'yes' &&
    css`
      pointer-events: none;
      font-size: 24px;
      font-weight: 500;
    `}
`;
